/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'eligibility-engine';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/eligibility-engine/v4/breeze/public
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: internal ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:EligibleBreezeSkusResource+type:symbol+getPublicEligibleBreezeSkus&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Eligible_Breeze_Skus-post-%2Feligibility-engine%2Fv4%2Fbreeze%2Fpublic'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Feligibility-engine%2Fv4%2Fbreeze%2Fpublic?showRequestDetails=true&body=%7B%22countryCode%22:%22string%22,%22selectedApiNames%22:%5B%22string%22%5D%7D&authType=internal)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getPublicEligibleBreezeSkusRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v4/breeze/public'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * post-/eligibility-engine/v4/onboarding
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:RequiredOnboardingResource+type:symbol+getRequiredOnboarding&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Required_Onboarding-post-%2Feligibility-engine%2Fv4%2Fonboarding'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/post/api.hubapi.com%2Feligibility-engine%2Fv4%2Fonboarding?showRequestDetails=true&body=%7B%22productConfigurations%22:%5B%7B%22skuId%22:0,%22quantity%22:0%7D%5D%7D&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getRequiredOnboardingRpc = freeze({
  baseUrl,
  method: 'post',
  pathSegments: freeze(['v4/onboarding'])
});